import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalProperties } from '@shared/models/classes/GlobalProperties';
import { ScheduleVisitService } from '../../schedule-visit-view/schedule-visit.service';
import { ButtonComponent } from '../button/button.component';
import { TextHeaderComponent } from '../text-header/text-header.component';

@Component({
  standalone: true,
  selector: 'section-1',
  imports: [ButtonComponent, TextHeaderComponent],
  templateUrl: './section-1.component.html',
  styleUrls: ['./section-1.component.scss', '../section.scss'],
})
export class Section1Component extends GlobalProperties {
  constructor(
    private router: Router,
    private _scheduleVisitService: ScheduleVisitService,
  ) {
    super();
  }

  onPlanVisit() {
    this._scheduleVisitService.clear();
    this.router.navigate([this.ROUTES.NEW_VISIT.value]);
  }
}
